import React, { useState } from 'react';
import ActionsMenu from '../../../../components/ActionsMenu';
import ListItemHoverTooltip from '../../../../components/ListItemHoverTooltip';
import { getFamilyShareInfo, getShareTooltip } from '../../../ProjectDashboard/utils/projectShareUtils';

/**
 * FamilyListItem component
 * Individual family item in the family list with selection and edit capabilities
 */
export default function FamilyListItem({
    family,
    projects,
    isSelected,
    onSelectFamily,
    onEditFamily,
    onExportFamily,
    onShareFamily,
    onDeleteFamily,
    onOpenSimulator
}) {
    const [menuOpen, setMenuOpen] = useState(false);
    const shareInfo = getFamilyShareInfo(family.id, projects);
    const shareTooltip = getShareTooltip(shareInfo);
    const updatedAt = family.lastChangeDate
        ? new Date(family.lastChangeDate).toLocaleDateString()
        : '';
    const updatedBy = family.lastChangeUser || 'System';

    const tooltipContent = (
        <span style={{
            fontSize: '0.7rem',
            color: 'var(--text-secondary)'
        }}>
            Updated {updatedAt} by {updatedBy}
        </span>
    );

    return (
        <ListItemHoverTooltip content={tooltipContent} disabled={menuOpen}>
            <div
                onClick={() => onSelectFamily(family.id)}
                onKeyDown={(event) => {
                    if (event.target !== event.currentTarget) return;
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        onSelectFamily(family.id);
                    }
                }}
                tabIndex={0}
                className={`rule-list-item-hover clickable-row${isSelected ? ' is-selected' : ''}`}
                style={{
                    padding: '0.25rem 1rem',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '0.5rem',
                    position: 'relative'
                }}
            >
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', minWidth: 0, flex: 1 }}>
                    <h3 className="row-title" style={{ fontSize: '0.9rem', margin: 0 }}>
                        {family.name}
                    </h3>
                    {shareInfo.isShared && (
                        <span
                            title={shareTooltip}
                            aria-label={shareTooltip}
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                fontSize: '0.85rem',
                                flexShrink: 0
                            }}
                        >
                            <i className="fa-solid fa-share-nodes"></i>
                        </span>
                    )}
                </div>
                <ActionsMenu
                    label={`${family.name} actions`}
                    onOpenChange={setMenuOpen}
                    items={[
                        {
                            label: 'Edit Family',
                            icon: 'fa-solid fa-pen',
                            onSelect: (event) => onEditFamily(event, family.id)
                        },
                        {
                            label: 'Export Family',
                            icon: 'fa-solid fa-file-export',
                            onSelect: () => onExportFamily(family.id, family.name)
                        },
                        {
                            label: 'Share with project',
                            icon: 'fa-solid fa-share-nodes',
                            onSelect: () => onShareFamily(family)
                        },
                        {
                            label: 'Run Simulator',
                            icon: 'fa-solid fa-flask-gear',
                            onSelect: () => onOpenSimulator(family.id)
                        },
                        {
                            label: 'Delete Family',
                            icon: 'fa-solid fa-trash-can',
                            danger: true,
                            onSelect: (event) => onDeleteFamily(event, family.id)
                        }
                    ]}
                />
            </div>
        </ListItemHoverTooltip>
    );
}
